<template>
  <div class="flex w-full pt-3 mb-5 space-x-4 rounded-md">
    <div class="relative flex items-stretch flex-grow ml-5 focus-within:z-10">
      <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
        <Search class="z-10 w-5 h-5 text-gray-400" aria-hidden="true" />
      </div>
      <TextInput
        :value="search_term"
        input-classes="appearance-none block relative w-full pl-3"
        name="search_term"
        type="text"
        :class="[{ 'mr-10': $store.state.auth.user.user_type == 'end_user' }]"
        :validate-on-input="true"
        :label="$t('Search workspaces')"
        :icon="true"
        @update:modelValue="
          (e) => {
            $emit('update:searchTerm', e)
          }
        " />
    </div>
    <div v-if="$store.state.auth.user.user_type !== 'end_user'" class="pr-5">
      <button class="h-10 btn primary-btn w-36" @click="$emitter.emit(ALL_EMITTERS.CREATE_NEW_WORKSPACE)">
        <Plus class="w-6 h-6" />
        <span class="ml-2">{{ $t("Create New") }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import { Search, Plus } from "lucide-vue-next"
import TextInput from "@/components/shared/TextInput.vue"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"

export default {
  components: { Search, Plus, TextInput },
  props: {},
  emits: ["update:searchTerm"],
  data() {
    return {
      ALL_EMITTERS,
      search_term: ""
    }
  },
  watch: {
    search_term() {}
  },

  created() {},

  methods: {}
}
</script>
